import type { MatrixAbsenceExcuse } from '../components/WorkJourneyMatrixAbsenceDrawer';

const CLARIFICATIONS_MAX = 100;

export type MatrixAbsenceSubmitInput = {
  excuse: MatrixAbsenceExcuse;
  reasonType?: string | null;
  startDate: string;
  endDate: string;
  durationMode: 'single' | 'range';
  description?: string | null;
};

export type MatrixAbsenceSubmitPayload = {
  excuse: MatrixAbsenceExcuse;
  reasonType: string | null;
  startDate: string;
  endDate: string;
  description: string;
};

/** Normalizes matrix absence drawer values into the createAbsence payload shape. */
export const buildMatrixAbsenceSubmitPayload = (
  input: MatrixAbsenceSubmitInput,
): MatrixAbsenceSubmitPayload | null => {
  const startDate = input.startDate?.trim();
  if (!startDate) return null;

  const endDate =
    input.durationMode === 'single' ? startDate : input.endDate?.trim() || startDate;

  return {
    excuse: input.excuse,
    reasonType: input.excuse === 'justified_absence' ? input.reasonType || null : null,
    startDate,
    endDate,
    description: (input.description || '').trim().slice(0, CLARIFICATIONS_MAX),
  };
};
